var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 5.33335V3.80002C13.3333 3.05328 13.3333 2.67992 13.188 2.3947C13.0602 2.14382 12.8562 1.93984 12.6053 1.81201C12.3201 1.66669 11.9467 1.66669 11.2 1.66669H3.46665C2.71991 1.66669 2.34654 1.66669 2.06133 1.81201C1.81044 1.93984 1.60647 2.14382 1.47864 2.3947C1.33331 2.67992 1.33331 3.05328 1.33331 3.80002V10.2C1.33331 10.9468 1.33331 11.3201 1.47864 11.6053C1.60647 11.8562 1.81044 12.0602 2.06133 12.188C2.34654 12.3334 2.71991 12.3334 3.46665 12.3334L11.2 12.3334C11.9467 12.3334 12.3201 12.3334 12.6053 12.188C12.8562 12.0602 13.0602 11.8562 13.188 11.6053C13.3333 11.3201 13.3333 10.9468 13.3333 10.2V8.66669M9.99998 7.00002C9.99998 6.69025 9.99998 6.53537 10.0256 6.40657C10.1308 5.87765 10.5443 5.46418 11.0732 5.35897C11.202 5.33335 11.3569 5.33335 11.6666 5.33335H13C13.3097 5.33335 13.4646 5.33335 13.5934 5.35897C14.1224 5.46418 14.5358 5.87765 14.641 6.40657C14.6666 6.53537 14.6666 6.69025 14.6666 7.00002C14.6666 7.30979 14.6666 7.46468 14.641 7.59347C14.5358 8.12239 14.1224 8.53586 13.5934 8.64107C13.4646 8.66669 13.3097 8.66669 13 8.66669H11.6666C11.3569 8.66669 11.202 8.66669 11.0732 8.64107C10.5443 8.53586 10.1308 8.12239 10.0256 7.59347C9.99998 7.46467 9.99998 7.30979 9.99998 7.00002Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.afeb7d41.svg";
export { ForwardRef as ReactComponent };